import React, { useState, useEffect } from "react";
import "./benifits-card.m.css";
import { SUBSCRIBER_FEATURES_MOB} from "../../../../../constants";
import Icon from "@mdi/react";
import { mdiArrowDown } from "@mdi/js";

const BenifitsCard = ({ setActive, isActive }) => {
  const [benifits, setBenifits] = useState(SUBSCRIBER_FEATURES_MOB);
  useEffect(() => {
    setBenifits(SUBSCRIBER_FEATURES_MOB.slice(0, 6));
  }, []);

  const handleChange = () => {
    setActive(false);
    setBenifits(SUBSCRIBER_FEATURES_MOB);
  };
  return (
    <div styleName="benifits-card">
      <div styleName="heading-wrap">
        <div styleName="divider-icon"></div>
        <img src="/icons/left-line-mb.svg" className="mobile-only" />
        <span styleName="heading">SUBSCRIBER BENEFITS</span>
        <img src="/icons/right-line-mb.svg" className="mobile-only" />
        <div styleName="divider-icon"></div>
      </div>
      <div styleName="card-list">
        {benifits.map((list, index) => (
          <div styleName="icon-title" key={index}>
            <img src={list.link2} styleName="sub-icon" alt={list.title} />
            <div styleName="sub-title">{list.title}</div>
            {list.desc === "Bloomberg" ? (
              <div styleName="sub-desc bloomberg"><img src="/icons/Bloomberg_grey.svg" alt={list.desc} styleName='bloomberg-icon' /> Stories</div>
            ) : (
              <div styleName="sub-desc">{list.desc}</div>
            )}
          </div>
        ))}
      </div>
      <div
        styleName={`btn-wrap ${!isActive ? "btn-none" : ""}`}
        onClick={() => handleChange()}
      >
        <span styleName="view-btn">
         View All Benefits <Icon path={mdiArrowDown} size={"18px"} />
        </span>
      </div>
    </div>
  );
};

export default BenifitsCard;
